module.exports = __webpack_public_path__ + "static/fonts/Lato-Regular.7f690e50.ttf";